import { FunctionComponent } from "react";
import { useNumericFormat } from "react-number-format";

import { getCurrencySymbol } from "@helloaudio/utils";
import { PaymentType, PaymentFrequency, useSignupForm } from "./SignupForm";
import clsx from "clsx";

interface PricingBreakdownProps {
  className?: string;
  pricingOption?: ReturnType<typeof useSignupForm>["pricingOption"];
}

const PriceBreakdown: FunctionComponent<PricingBreakdownProps> = ({ className, pricingOption }) => {
  const { format: formatPrice } = useNumericFormat({
    decimalScale: 2,
    fixedDecimalScale: true,
    thousandSeparator: true,
  });

  return (
    <div
      className={clsx(
        className,
        "tw-grid tw-grid-cols-1 tw-border tw-border-solid tw-border-gray-300 tw-shadow-md tw-px-5 tw-rounded tw-divide-y",
      )}
    >
      {!pricingOption && (
        <div className="tw-py-5 tw-font-medium tw-text-base tw-text-gray-900">
          Please select pricing option
        </div>
      )}

      {pricingOption && (
        <div className="tw-border-0 tw-border-solid tw-border-gray-300 tw-py-5 tw-flex tw-justify-between">
          <div>
            <span className="tw-block tw-font-bold tw-text-base tw-text-gray-900">
              {pricingOption.paymentType === PaymentType.OneTime && "Total"}
              {pricingOption.paymentType === PaymentType.Recurring && (
                <>
                  {pricingOption.paymentFrequency === PaymentFrequency.Weekly && "Weekly payments"}
                  {pricingOption.paymentFrequency === PaymentFrequency.Monthly &&
                    "Monthly payments"}
                  {pricingOption.paymentFrequency === PaymentFrequency.Annually &&
                    "Annual payments"}
                </>
              )}
            </span>

            {pricingOption.paymentType === PaymentType.Recurring && (
              <span className="tw-block tw-text-sm tw-text-gray-500">
                {!pricingOption.repeatPayment && "Starting today"}
                {pricingOption.repeatPayment &&
                  `Starting today and repeating ${pricingOption.numberOfPayments - 1} more times`}
              </span>
            )}
          </div>

          <span className="tw-font-medium tw-text-base tw-text-gray-900">
            {getCurrencySymbol(pricingOption.currency)}
            {formatPrice((pricingOption.paymentAmount / 100).toString())}
          </span>
        </div>
      )}
    </div>
  );
};

export default PriceBreakdown;
